import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import SearchWorkplaceMember from './SearchWorkplaceMember';

loadDOMComponent({
	selector: 'react-search-workplace-member',
	callback: ({ container }) => {
		const linkSelect = container.getAttribute('linkSelect') || null;
		const gqlParams = JSON.parse(container.getAttribute('gqlParams') || '{}');
		const hideFavoriteButton =
			container.getAttribute('hideFavoriteButton') !== null;
		const hideEmptySearch = container.getAttribute('hideEmptySearch') !== null;
		const workplaceFromElement = container.getAttribute('workplaceFromElement');
		const patientId = container.getAttribute('patientId');

		// selectLink
		ReactDOM.render(
			<AppContextProvider>
				<SearchWorkplaceMember
					linkSelect={linkSelect}
					gqlParams={gqlParams}
					hideFavoriteButton={hideFavoriteButton}
					hideEmptySearch={hideEmptySearch}
					workplaceFromElement={workplaceFromElement}
					patientId={patientId}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
